import { defineMessages } from 'react-intl-next';

export const elementInsertSidePanel = defineMessages({
	title: {
		id: 'fabric.editor.elementInsertSidePanel.title',
		defaultMessage: 'Insert',
		description: 'Title of a panel that opens on the side',
	},
});
